(function() {
  var IB_TIERS = [
    { name: 'Starter', min: 2,  max: 4,   disc: 0.10, color: '#c49a4a' },
    { name: 'Dealer',  min: 5,  max: 9,   disc: 0.18, color: '#5aab7a' },
    { name: 'Elite',   min: 10, max: 19,  disc: 0.25, color: '#d97d6c' },
    { name: 'VIP',     min: 20, max: 9999, disc: 0.32, color: '#4a90c4' }
  ];
  function ibGetTier(qty) {
    for (var i = 0; i < IB_TIERS.length; i++) {
      if (qty >= IB_TIERS[i].min && qty <= IB_TIERS[i].max) return IB_TIERS[i];
    }
    return null;
  }
  function ibFmt(n) { return '$' + Math.round(n).toLocaleString('en-US'); }
  function ibCalcUpdate() {
    var sel = document.getElementById('ib-prod-select');
    var qtyEl = document.getElementById('ib-qty-input');
    if (!sel || !qtyEl) return;
    var retail = parseInt(sel.value, 10);
    var qty = Math.max(1, parseInt(qtyEl.value, 10) || 1);
    var tier = ibGetTier(qty);
    var disc = tier ? tier.disc : 0;
    var unitPrice = retail * (1 - disc);
    var total = unitPrice * qty;
    var saved = retail * qty - total;
    document.getElementById('ib-res-unit').textContent = ibFmt(unitPrice);
    document.getElementById('ib-res-total').textContent = ibFmt(total);
    document.getElementById('ib-res-save').textContent = ibFmt(saved);
    if (tier) {
      document.getElementById('ib-tier-name').textContent = tier.name;
      document.getElementById('ib-tier-pct').textContent = Math.round(disc * 100) + '% discount';
      document.getElementById('ib-bar-fill').style.width = Math.round((disc / 0.32) * 100) + '%';
    } else {
      document.getElementById('ib-tier-name').textContent = 'None - order 2+ to unlock';
      document.getElementById('ib-tier-pct').textContent = '0% discount';
      document.getElementById('ib-bar-fill').style.width = '0%';
    }
  }
  function ibBuildTable(retail) {
    var rows = [
      { label: 'Single unit', qty: '1',     disc: 0,    tier: null },
      { label: 'Starter',     qty: '2-4',   disc: 0.10, color: '#c49a4a' },
      { label: 'Dealer',      qty: '5-9',   disc: 0.18, color: '#5aab7a' },
      { label: 'Elite',       qty: '10-19', disc: 0.25, color: '#d97d6c' },
      { label: 'VIP',         qty: '20+',   disc: 0.32, color: '#4a90c4' }
    ];
    var html = '';
    rows.forEach(function(r) {
      var price = retail * (1 - r.disc);
      var save = retail * r.disc;
      var dot = r.color ? '<span class="ib-pt-tier-dot" style="background:' + r.color + ';"></span>' : '<span class="ib-pt-tier-dot" style="background:#ccc;"></span>';
      var pill = r.disc > 0 ? '<span class="ib-pt-pill" style="background:' + r.color + '18;color:' + r.color + ';">-' + Math.round(r.disc * 100) + '%</span>' : '<span style="color:#aaa;font-size:12px;">Retail</span>';
      var saveCell = r.disc > 0 ? '<span style="color:#5aab7a;">' + ibFmt(save) + '</span>' : '-';
      html += '<tr><td>' + dot + r.label + '</td><td>' + r.qty + '</td><td><strong>' + ibFmt(price) + '</strong></td><td>' + saveCell + '</td><td>' + pill + '</td></tr>';
    });
    document.getElementById('ib-pt-rows').innerHTML = html;
  }
  window.ibWsShowTable = function(btn, price) {
    document.querySelectorAll('.ib-pt-tab').forEach(function(t) { t.classList.remove('ib-pt-tab--active'); });
    btn.classList.add('ib-pt-tab--active');
    ibBuildTable(price);
  };
  document.addEventListener('DOMContentLoaded', function() {
    var sel = document.getElementById('ib-prod-select');
    var qty = document.getElementById('ib-qty-input');
    if (sel) sel.addEventListener('change', ibCalcUpdate);
    if (qty) qty.addEventListener('input', ibCalcUpdate);
    ibCalcUpdate();
    var firstPrice = sel ? parseInt(sel.options[0].value, 10) : 3500;
    ibBuildTable(firstPrice);
    document.querySelectorAll('.ib-faq-q').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var expanded = this.getAttribute('aria-expanded') === 'true';
        this.setAttribute('aria-expanded', String(!expanded));
        var ans = this.nextElementSibling;
        if (ans) ans.classList.toggle('open', !expanded);
      });
    });
  });
})();